export default {
  scheduledTransfers: 'scheduled-transfers',
  transfers: 'transfers',
  positionJournalTransfers: 'position-journal-transfers',
  recentTransfers: 'recent-transfers',
  cashBalances: 'cash-balances',
  achRel: 'ach-relationships',
  searchAccounts: 'search-accounts',
  accountLookup: 'account-lookup',
  sessionUser: 'session-user'
}
